export const SCROLLED_CLASS = 'is-scrolled';
export const TEXTAREA_SELECTOR = '.input-group .form-floating > textarea:not([data-textarea-scroll-added="true"])';

export const update = ( textarea ) => {
    const wrapper = textarea.closest( '.form-floating' );
    if ( !wrapper ) {
        return;
    }

    wrapper.classList.toggle( SCROLLED_CLASS, textarea.scrollTop > 0 );
};

export const initTextarea = ( textarea ) => {
    textarea.setAttribute( 'data-textarea-scroll-added', 'true' );

    update( textarea );
    textarea.addEventListener( 'scroll', () => update( textarea ) );
    // Wird der Wert per Skript geleert - etwa vom Clearer - setzt der Browser
    // scrollTop zurueck, ohne ein scroll-Event zu schicken.
    textarea.addEventListener( 'input', () => update( textarea ) );
};

export const init = ( selector = TEXTAREA_SELECTOR ) => {
    document.querySelectorAll( selector ).forEach( initTextarea );
};
